// ============================================================================
// PORTUGUESE TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Coleção de versículos inspiradores com referências Strong

export const bibleVerses = [
  {
    reference: "Filipenses 4:13",
    text: "Tudo posso naquele que me fortalece",
    version: "ARA",
    theme: "força",
    strongNumbers: {
      "posso": "G1411", // δύναμις (dynamis) = poder, força
      "fortalece": "G1743" // ἐνδυναμόω (endynamoo) = fortalecer
    },
    context: "Paulo fala sobre sua capacidade de enfrentar todas as situações através de Cristo"
  },
  {
    reference: "Salmo 23:1",
    text: "O SENHOR é o meu pastor; nada me faltará",
    version: "ARA",
    theme: "proteção",
    strongNumbers: {
      "pastor": "H7462", // רָעָה (ra'ah) = pastorear, cuidar
      "faltará": "H2637" // חָסֵר (chaser) = faltar, necessitar
    },
    context: "Davi expressa sua total confiança na providência divina"
  },
  {
    reference: "João 3:16",
    text: "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito",
    version: "ARA",
    theme: "amor",
    strongNumbers: {
      "amou": "G25", // ἀγαπάω (agapao) = amar incondicionalmente
      "deu": "G1325" // δίδωμι (didomi) = dar, oferecer
    },
    context: "O versículo mais célebre sobre o amor de Deus pela humanidade"
  },
  {
    reference: "Filipenses 4:7",
    text: "E a paz de Deus, que excede todo o entendimento, guardará os vossos corações",
    version: "ARA",
    theme: "paz",
    strongNumbers: {
      "paz": "G1515", // εἰρήνη (eirene) = paz, harmonia
      "guardará": "G5432" // φρουρέω (phroureo) = guardar, proteger
    },
    context: "Promessa de proteção divina através da paz interior"
  },
  {
    reference: "Salmo 119:105",
    text: "Lâmpada para os meus pés é a tua palavra e luz, para os meus caminhos",
    version: "ARA",
    theme: "guia",
    strongNumbers: {
      "lâmpada": "H5216", // נִיר (niyr) = lâmpada, luminária
      "luz": "H216" // אוֹר (or) = luz, iluminação
    },
    context: "A Palavra de Deus como guia na vida cotidiana"
  },
  {
    reference: "Provérbios 3:5-6",
    text: "Confia no SENHOR de todo o teu coração e não te estribes no teu próprio entendimento",
    version: "ARA",
    theme: "confiança",
    strongNumbers: {
      "Confia": "H982", // בָּטַח (batach) = confiar
      "coração": "H3820" // לֵב (leb) = coração, mente, vontade
    },
    context: "Convite a confiar em Deus em vez de nossas próprias capacidades"
  },
  {
    reference: "Mateus 5:14",
    text: "Vós sois a luz do mundo. Não se pode esconder a cidade edificada sobre um monte",
    version: "ARA",
    theme: "testemunho",
    strongNumbers: {
      "luz": "G5457", // φῶς (phos) = luz, iluminação espiritual
      "mundo": "G2889" // κόσμος (kosmos) = mundo, universo
    },
    context: "Jesus encoraja seus discípulos a serem testemunhas no mundo"
  }
];

export default bibleVerses;
